/** @jsxImportSource theme-ui */
import { Container, Flex } from 'theme-ui';
import CompanyDeletionSchedules from '@/containers/companyDeletionSchedules/CompanyDeletionSchedules';

const CompanyDeletionSchedulesPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <CompanyDeletionSchedules />
            </Flex>
        </Container>
    );
};

export default CompanyDeletionSchedulesPage;
